import * as React from "react";
import { RichBanner, ContentBanner, Banner } from "@grandvisionhq/content";
import { Heading } from "@grandvisionhq/elements";
import { compose } from "@grandvisionhq/utils";
import { RichBannerCampaignContainer } from "../../../../components/RichBannerCampaign/components/RichBannerCampaign/RichBannerCampaignContainer.js";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { ProductListingRow } from "../../../../components/ProductListingRow/components/ProductListingRow/ProductListingRow.js";
import { useBloomreachLinks } from "../../../../hooks/hooks/use-bloomreach-links.js";
import { parseBloomreachImage } from "../../../../utils/utils/parse-bloomreach-image.js";
const CmsBanner = ({ content, template, meta }) => {
  const { title, description, content: richText, titleSemantic } = content;
  const links = useBloomreachLinks(content.links);
  const image = parseBloomreachImage(content.image);
  const tooltip = content.tooltip?.showTooltip ? content.tooltip : void 0;
  switch (template) {
    case "full-width":
      return /* @__PURE__ */ React.createElement(
        Banner,
        {
          image: image?.original,
          mobileImage: image?.mobile,
          link: links[0],
          tooltip
        }
      );
    case "contained-banner":
      return /* @__PURE__ */ React.createElement(
        Banner,
        {
          image: image?.original,
          mobileImage: image?.mobile,
          link: links[0],
          useContainer: true,
          tooltip
        }
      );
    case "top-banner":
      return /* @__PURE__ */ React.createElement(
        Banner,
        {
          image: image?.original,
          mobileImage: image?.mobile,
          link: links[0],
          useContainer: true,
          useLazyLoading: false,
          tooltip
        }
      );
    case "content-banner":
      return /* @__PURE__ */ React.createElement(
        ContentBanner,
        {
          image: image?.original,
          mobileImage: image?.mobile,
          links,
          title,
          text: description,
          textColor: meta.textColor,
          tooltip,
          titleSemantic,
          bannerHeight: meta.bannerHeight
        }
      );
    case "rich-banner":
      const products = content?.products ?? [];
      const richBannerTooltip = meta.tooltip?.title ? meta.tooltip : tooltip;
      return /* @__PURE__ */ React.createElement(
        RichBanner,
        {
          ...meta,
          image: image?.original,
          mobileImage: image?.mobile,
          richText: richText?.value,
          link: links.find((l) => l.style === "image"),
          tooltip: richBannerTooltip,
          backgroundColor: meta?.backgroundColorHex || meta?.backgroundColor
        },
        products.length > 0 && /* @__PURE__ */ React.createElement(ProductListingRow, { skus: products })
      );
    case "rich-banner-with-campaign":
      if (!content.campaignId) {
        return /* @__PURE__ */ React.createElement(Heading, { variant: "subheading1" }, "Campaign Banner rendered without campaignId - please add it in BloomReach.");
      }
      return /* @__PURE__ */ React.createElement(
        RichBannerCampaignContainer,
        {
          ...meta,
          campaignId: content.campaignId,
          image: image?.original,
          mobileImage: image?.mobile,
          richText: richText?.value,
          link: links.find((l) => l.style === "image")
        }
      );
    default:
      return /* @__PURE__ */ React.createElement(Heading, { variant: "subheading1" }, "Banner with template: ", template, " is not defined in CmsBanner component.");
  }
};
const CmsBanner$1 = compose(
  withBreakpointVisibility,
  withBloomreachData,
  withEditableContent,
  withAnchor
)(CmsBanner);
export {
  CmsBanner,
  CmsBanner$1 as default
};
//# sourceMappingURL=Banner.js.map
